import { request } from "./request";
export const fetchNews = (
	loaderContext = {
		container: $("body"),
		size: 2
	},
	news,
	urlId,
	params,
	userLevel
) => {
	loaderContext.container.css("position", "relative");
	return new Promise(async (resolve, reject) => {
		try {
			const response = await request(params, loaderContext.container);
			if (urlId) {
				// expecting single item response
				resolve(
					{
						type: "single",
						data: response[0]
					},
					userLevel
				);
			} else {
				// expecting multiple items

				news = news.concat(response);
				loaderContext.container.find(".dimmer").remove();
				resolve(
					{
						type: "list",
						data: news
					},
					userLevel
				);
			}
		} catch (err) {
			loaderContext.container.find(".dimmer").remove();
			if (news.length > 0) {
				resolve(
					{
						type: urlId ? "single" : "list",
						data: news
					},
					userLevel
				);
			} else {
				reject(err);
			}
		}
	});
};
// end fetchNews function
